module.exports = __webpack_public_path__ + "img/组 128@2x.0d07b478.png";